"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.splitNotation = splitNotation;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireDefault(require("react"));
require("./TaskChordBuilder.css");
var _abcjs = _interopRequireDefault(require("@bittnerdevelopmentgroup/abcjs"));
var _MusicEditor = _interopRequireDefault(require("./MusicEditor"));
var _DesignComponents = require("../DesignComponents/DesignComponents");
var _MusicUtil = require("./MusicUtil");
var _CompletedContext = require("../CompletedContext");
var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));
var _questionMarkIcon = _interopRequireDefault(require("../assets/question-mark-icon.png"));
var _FeedbackIcon = _interopRequireDefault(require("../FeedbackIcon/FeedbackIcon"));
// import axios from 'axios';

var DEBUG = false;
function splitNotation(notation, vb) {
  var split = notation;
  if (vb) {
    split = notation.split(/(?=[A-Za-z|])/);
  } else {
    split = notation.replace('[', '').replace(']', '').split(/(?=[A-Za-z|])/);
  }
  for (var i = 0; i < split.length; i++) {
    // split[i] = split[i].replace(/\s/g, "")

    if ('^^__'.includes(split[i].slice(-2))) {
      split[i + 1] = split[i].slice(-2) + split[i + 1];
      split[i] = split[i].slice(0, -2);
    } else if ('^_='.includes(split[i].slice(-1))) {
      split[i + 1] = split[i].slice(-1) + split[i + 1];
      split[i] = split[i].slice(0, -1);
    }
  }
  split = split.filter(function (entry) {
    return entry !== " ";
  });
  if (split[0] === '') split.splice(split.indexOf(''), 1);
  return split;
}
var TaskChordBuilder = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskChordBuilder, _React$Component);
  var _super = (0, _createSuper2.default)(TaskChordBuilder);
  function TaskChordBuilder(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskChordBuilder);
    _this = _super.call(this, props);
    _this.markStaffLineAndSpaces = function (attemptPitches, correctLetters, cleff) {
      if (_this.musiceditor.current) {
        var correctPitches = splitNotation(correctLetters).map(function (v) {
          return (0, _MusicUtil.letter_to_pitch)(v, cleff);
        });
        var combined = attemptPitches.concat(correctPitches);
        var union = combined.filter(function (value, index, self) {
          return index === self.findIndex(function (t) {
            return t.pitch === value.pitch && t.verticalPos === value.verticalPos && t.accidental === value.accidental;
          });
        });
        var correctAnswers = attemptPitches.filter(function (i) {
          return correctPitches.find(function (v) {
            return v.pitch === i.pitch && v.accidental === i.accidental;
          });
        });
        var incorrectAnswers = union.filter(function (i) {
          return !correctAnswers.find(function (v) {
            return v.pitch === i.pitch && v.accidental === i.accidental;
          });
        });
        var elementsToMark = {};
        correctAnswers.map(function (v) {
          elementsToMark[v.verticalPos] = true;
        });
        incorrectAnswers.map(function (v) {
          elementsToMark[v.verticalPos] = false;
        });
        _this.setState({
          answerState: elementsToMark,
          correctPitches: correctPitches
        });
      }
    };
    _this.submitChord = function () {
      var parse = _abcjs.default.parseOnly(_this.state.precursor + _this.state.notation);
      var server_notation = "";
      if (parse[0].lines[0].staff[0].voices[0][0].pitches) {
        var clef = parse[0].lines[0].staff[0].clef.type;
        server_notation = parse[0].lines[0].staff[0].voices[0][0].pitches.map(function (note) {
          if (clef === "treble") {
            return (note.accidental ? _MusicUtil.accidentals[note.accidental] : "") + (0, _MusicUtil.get_treble_pitch)(note.pitch);
          } else if (clef === "bass") {
            return (note.accidental ? _MusicUtil.accidentals[note.accidental] : "") + (0, _MusicUtil.get_bass_pitch)(note.verticalPos);
          } else if (clef === "alto") {
            return (note.accidental ? _MusicUtil.accidentals[note.accidental] : "") + (0, _MusicUtil.get_alto_pitch)(note.verticalPos);
          }
          return "";
        });
        _this.markStaffLineAndSpaces(parse[0].lines[0].staff[0].voices[0][0].pitches, _this.state.correctAnswer, clef);
        if (_this.props.answers) {
          var found = false;
          for (var i = 0; i < _this.props.answers.length; ++i) {
            var answer = splitNotation(_this.props.answers[i].answer);
            if (_this.arraysAreIdentical(server_notation.sort(), answer.sort())) {
              found = true;
              _this.setState({
                completed: _this.props.answers[i].correct,
                showAnswer: _this.state.correct !== undefined,
                correct: _this.props.answers[i].correct,
                showModal: true,
                showNag: _this.state.showAnswer,
                feedback: _this.props.answers[i].feedback
              });
              if (!_this.props.answers[i].correct) {
                _this.setState({
                  showFeedback: true
                });
              }
            }
          }
          if (!found) {
            _this.setState({
              completed: false,
              showAnswer: _this.state.correct !== undefined,
              correct: false,
              showModal: true,
              showNag: _this.state.showAnswer,
              feedback: _this.props.feedbackIncorrect,
              showFeedback: true
            });
          }
        } else {
          var correct = splitNotation(_this.state.correctAnswer);
          var match = _this.arraysAreIdentical(server_notation.sort(), correct.sort());
          _this.setState((0, _defineProperty2.default)({
            completed: match,
            showAnswer: _this.state.correct !== undefined,
            correct: match,
            showModal: !match,
            showNag: _this.state.showAnswer,
            feedback: match ? _this.props.feedbackCorrect : _this.props.feedbackIncorrect
          }, "showModal", true));
          if (!match) {
            _this.setState({
              showFeedback: true
            });
          }
        }
      }
    };
    DEBUG && console.log("ChordBuilder constructor");
    _this.state = props.state || {};
    var musicInitial = _this.props.musicInitial;
    if (musicInitial === "[]" || musicInitial === "") musicInitial = 'z';
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = false;
      _this.state.showAnswer = false;
      _this.state.notation = _this.props.notation || _this.props.musicInitial || _this.props.notation_initial || "[z]";
      _this.state.notation = musicInitial || _this.state.notation;
      _this.state.correctAnswer = _this.props.correct || _this.props.answers.find(function (a) {
        return a.correct;
      }).answer;
      _this.state.musicInitial = musicInitial;
      _this.state.precursor = _this.props.musicConfiguration.split(';').join('\n') + '\n';
      _this.state.answerState = {};
      _this.state.correctPitches = {};
      _this.state.showInfo = false;
      _this.state.cleff = "";
    }
    _this.musiceditor = /*#__PURE__*/_react.default.createRef();
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.staffRef = /*#__PURE__*/_react.default.createRef();
    _this.renderResetButton = _this.renderResetButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.renderSubmitButton = _this.renderSubmitButton.bind((0, _assertThisInitialized2.default)(_this));
    _this.changeAnswerState = _this.changeAnswerState.bind((0, _assertThisInitialized2.default)(_this));
    _this.showInfo = _this.showInfo.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(TaskChordBuilder, [{
    key: "changeAnswerState",
    value: function changeAnswerState(newAnswerState) {
      this.setState({
        answerState: newAnswerState
      });
    }
  }, {
    key: "arraysAreIdentical",
    value: function arraysAreIdentical(arr1, arr2) {
      if (arr1.length !== arr2.length) return false;
      for (var i = 0, len = arr1.length; i < len; i++) {
        if (arr1[i] !== arr2[i]) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "checkIfNoteInNotation",
    value: function checkIfNoteInNotation(correctNote, notation) {
      var _this2 = this;
      var parsedResponse = _abcjs.default.parseOnly(this.state.precursor + notation);
      var t = 0;
      if (!parsedResponse[0].lines[0].staff[0].voices[0][0].pitches) return;
      parsedResponse[0].lines[0].staff[0].voices[0][0].pitches.forEach(function (notationNote) {
        if (_this2.arraysAreIdentical(Object.values(notationNote), Object.values(correctNote))) t++;
      });
      return t;
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;
      DEBUG && console.log("TaskChordBuilder componentDidMount");
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this3.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      var _this$props$answers;
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
      var musicInitial = this.props.musicInitial;
      if (musicInitial === "[]" || musicInitial === "") musicInitial = 'z';
      this.state.correctAnswer = this.props.correct || ((_this$props$answers = this.props.answers) === null || _this$props$answers === void 0 ? void 0 : _this$props$answers.find(function (a) {
        return a.correct;
      }).answer);
      this.state.musicInitial = musicInitial;
      this.state.precursor = this.props.musicConfiguration.split(';').join('\n') + '\n';
      if (prevprops.musicInitial !== this.props.musicInitial) {
        DEBUG && console.log("ChordBuilder componentDidUpdate props.musicInitial changed");
        this.state.notation = this.props.notation || this.props.musicInitial || this.props.notation_initial || "[z]";
        this.state.notation = musicInitial || this.state.notation;
      }
    }
  }, {
    key: "onChange",
    value: function onChange(newNotation) {
      this.setState({
        notation: newNotation
      });
    }
  }, {
    key: "renderResetButton",
    value: function renderResetButton(_onClick) {
      var _this4 = this;
      return /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        variant: "outline",
        color: "white",
        disabled: (this.state.correct || this.state.notation === this.props.musicInitial) && Object.keys(this.state.answerState).length === 0,
        style: {
          margin: "0px 12px"
        },
        className: this.state.correct || this.state.notation === this.props.musicInitial ? "music-function-button-disabled" : "music-function-button-enabled",
        onClick: function onClick() {
          _onClick();
          var newNotation = _this4.state.musicInitial;
          _this4.musiceditor.current.setState({
            accidental: ""
          });
          _this4.setState({
            notation: newNotation,
            reset: true,
            answerState: {}
          });
        }
      }, "Reset Staff");
    }
  }, {
    key: "renderSubmitButton",
    value: function renderSubmitButton() {
      var _this5 = this;
      var disabled = this.state.correct || this.state.notation.trim() === "z";
      return /*#__PURE__*/_react.default.createElement(_DesignComponents.Button, {
        variant: "dark",
        disabled: disabled,
        style: {
          float: "right"
        },
        className: disabled ? "music-function-button-disabled" : "music-function-button-enabled",
        onClick: function onClick() {
          var newChord = _this5.state.notation.slice();
          _this5.setState({
            lastChordNotation: newChord
          });
          _this5.submitChord();
        }
      }, "Submit");
    }
  }, {
    key: "showInfo",
    value: function showInfo() {
      this.setState({
        showInfo: true,
        showModal: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this,
        _this$props$zoom,
        _this$props$zoom2;
      DEBUG && console.log("TaskChordBuilder render");
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "task task-chord-builder",
        style: this.props.style
      }, /*#__PURE__*/_react.default.createElement("p", {
        className: "chord-instruction"
      }, "Select a location to add notes to staff by using the up or down arrow keys to move between the lines and spaces. Use the spacebar or return key to add, delete, or modify a note at the cursor location.", /*#__PURE__*/_react.default.createElement("span", {
        className: "sr-only"
      }, "Use the hot key: ", navigator.userAgent.toLowerCase().indexOf('win') >= 0 ? " Alt " : " Command ", "-Shift-1, to get a full read out of the current score."), /*#__PURE__*/_react.default.createElement("div", {
        role: "button",
        style: {
          display: "inline-block"
        },
        tabIndex: "0",
        "aria-label": "Explanation of symbols",
        onClick: this.showInfo,
        onKeyDown: function onKeyDown(e) {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            e.stopPropagation();
            _this6.showInfo();
          }
        }
      }, /*#__PURE__*/_react.default.createElement("img", {
        className: "revert-dark-mode",
        style: {
          width: "20px",
          height: "20px",
          marginBottom: "4px",
          marginLeft: "4px"
        },
        src: _questionMarkIcon.default,
        alt: ""
      }))), /*#__PURE__*/_react.default.createElement("div", {
        className: "chord-builder-container",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "chord-builder",
        ref: this.ref
      }, this.state.completed && !this.state.correct && /*#__PURE__*/_react.default.createElement("p", {
        style: {
          padding: "10px",
          backgroundColor: "#f8d7da",
          borderRadius: "5px",
          border: "1px #f5c6cb solid"
        }
      }, "Your Submission:"), /*#__PURE__*/_react.default.createElement(_MusicEditor.default, Object.assign({
        ref: this.musiceditor
      }, this.props, this.state, {
        rangeLower: this.props.rangeLower,
        rangeUpper: this.props.rangeUpper,
        addClasses: true,
        addHotspots: true,
        accidentals: true,
        chordMode: true,
        millisecondsPerMeasure: this.props.musicDuration,
        zoom: (_this$props$zoom = this.props.zoom) !== null && _this$props$zoom !== void 0 ? _this$props$zoom : 4,
        precursor: this.state.precursor,
        notation: this.state.notation,
        correctPitches: this.state.correctPitches,
        onChange: this.onChange,
        completed: this.state.completed,
        chordAnswerState: this.state.answerState,
        changeAnswerState: this.changeAnswerState,
        renderResetButton: this.renderResetButton,
        renderSubmitButton: this.renderSubmitButton,
        altTextMode: this.props.altTextMode,
        showAnswer: this.state.showAnswer
      })))), this.state.showAnswer && !this.state.completed && /*#__PURE__*/_react.default.createElement("div", {
        className: "chord-builder-container",
        style: {
          width: '100%'
        }
      }, /*#__PURE__*/_react.default.createElement("p", {
        style: {
          fontSize: "12px",
          fontWeight: "bold",
          fontStretch: "normal",
          fontStyle: "italic",
          lineHeight: "1.83",
          letterSpacing: "normal",
          textAlign: "center",
          color: "#63768a",
          margin: "24px 0px 0px 0px"
        }
      }, "The correct answer is shown below. Update and submit the correct answer to move on."), /*#__PURE__*/_react.default.createElement(_MusicEditor.default, Object.assign({
        ref: this.musiceditor,
        staffRef: this.staffRef
      }, this.props, this.state, {
        rangeLower: this.props.rangeLower,
        rangeUpper: this.props.rangeUpper,
        addClasses: true,
        hintMode: true,
        chordMode: true,
        millisecondsPerMeasure: this.props.musicDuration,
        zoom: (_this$props$zoom2 = this.props.zoom) !== null && _this$props$zoom2 !== void 0 ? _this$props$zoom2 : 4,
        precursor: this.state.precursor,
        notation: this.state.correctAnswer,
        onChange: function onChange() {},
        completed: this.state.completed,
        renderSubmitButton: this.renderSubmitButton,
        altTextMode: this.props.altTextMode,
        showAnswer: this.state.showAnswer
      }))), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
        show: this.state.showModal,
        correct: this.state.showInfo ? undefined : this.state.completed,
        onHide: function onHide() {
          _this6.setState({
            showModal: false,
            showInfo: false
          });
        }
      }, this.state.showInfo ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, "These icons are used to differentiate answer feedback:", /*#__PURE__*/_react.default.createElement("ul", {
        style: {
          listStyle: 'none',
          marginTop: "10px"
        }
      }, /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_FeedbackIcon.default, {
        iconSize: "16px"
      }), " Incorrect"), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_FeedbackIcon.default, {
        correct: true,
        iconSize: "16px"
      }), " Correct"))) : this.state.feedback));
    }
  }]);
  return TaskChordBuilder;
}(_react.default.Component);
TaskChordBuilder.contextType = _CompletedContext.CompletedContext;
var _default = TaskChordBuilder;
exports.default = _default;